import { trackGoal } from './metrika';

/**
 * Маппинг номеров счётчиков Яндекс.Метрики → slug витрины для A/B-целей банкира.
 * Источник: TASK-DOCS/B24-91948-yandex-metrika/B24-91948-цели-по-счетчикам.md
 * Только 6 витрин, на которых проводится A/B-тест банкира.
 */
const COUNTER_TO_SLUG = {
  99973606: 'cash2you',     // cash2you.info
  103199669: 'kredmi',      // kredmi.ru
  104313313: 'tzaem',       // tzaem.ru
  107092459: '100zaimow',   // 100zaimow.info
  99769083: 'monetka',      // monetka.info
  103280576: 'denga',       // denga.info
};

/**
 * Отправляет цель A/B-теста банкира в Яндекс.Метрику:
 *   {slug}_bankiru_on  — телефон есть и пользователь попал в ролаут (банкир показан)
 *   {slug}_bankiru_off — телефон есть, но банкир выключен / не попал в процент
 *
 * Условия срабатывания:
 *   - есть номер счётчика Яндекс.Метрики и он входит в маппинг 6 витрин;
 *   - есть телефон (window.__bankiruPhone или ?ph=);
 *   - передано серверное значение bankiRuInRollout (не испорченное ?bankiru=1).
 *
 * Молча ничего не делает, если витрина не участвует в A/B-тесте или нет телефона —
 * аналитика не должна ломать витрину.
 *
 * @param {boolean} bankiRuInRollout — серверное значение ролаута из /api/visit/track
 *   (до клиентского форсирования ?bankiru=1).
 */
export function trackBankiRuAbGoal(bankiRuInRollout) {
  try {
    const counterId = typeof window !== 'undefined' ? window.__yaMetrikaId : null;
    if (!counterId) return;

    const slug = COUNTER_TO_SLUG[String(counterId)];
    if (!slug) return;

    const phone = (typeof window !== 'undefined' && window.__bankiruPhone)
      || new URLSearchParams(window.location.search).get('ph');
    if (!phone) return;

    const goalId = bankiRuInRollout ? `${slug}_bankiru_on` : `${slug}_bankiru_off`;
    trackGoal(goalId);
  } catch (_) {
    // Аналитика не должна ломать витрину
  }
}
